function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

export const PURCHASER_CONFIG_SAVE_NETWORK_ERROR_MESSAGE =
  "Failed to save purchaser configuration. Please try again later.";

export const PURCHASER_CONFIG_LOAD_NETWORK_ERROR_MESSAGE =
  "Failed to load purchaser configuration. Please try again later.";

/** True when a config template request failed because the browser/network could not complete it. */
export function isPurchaserConfigNetworkError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  if (
    normalized.includes("failed to fetch") ||
    normalized.includes("network error") ||
    normalized.includes("networkerror") ||
    normalized.includes("load failed") ||
    normalized.includes("network request failed")
  ) {
    return true;
  }
  return (
    error != null &&
    typeof error === "object" &&
    "networkError" in error &&
    (error as { networkError?: unknown }).networkError != null
  );
}

export function getPurchaserConfigSaveErrorMessage(error: unknown): string {
  if (isPurchaserConfigNetworkError(error)) {
    return PURCHASER_CONFIG_SAVE_NETWORK_ERROR_MESSAGE;
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return "Failed to save config template";
}

export function getPurchaserConfigLoadErrorMessage(error: unknown): string {
  if (isPurchaserConfigNetworkError(error)) {
    return PURCHASER_CONFIG_LOAD_NETWORK_ERROR_MESSAGE;
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return "Failed to load config template";
}
